import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from '@app/core';

// Modelos
import {
  SeriePredeterminada,
  TipoDocumentalPredeterminado,
  ClasificacionPredeterminada,
  ClasificacionPredeterminadaAPI,
  SubSeriePredeterminada
} from '@app/shared';

@Injectable()
export class DocumentsDataService {

  constructor (
    private http: HttpClient,
    private api: EndpointService
  ) { }

  /**
   * Consultar todas las series
   *
   * @returns {Observable<SeriePredeterminada[]>}
   * @memberof DocumentsDataService
   */
  getSeriesDocumentary(): Observable<SeriePredeterminada[]> {
    return new Observable(obs => {
      this.http.get<SeriePredeterminada[]>(this.api.get('adminSerie')).subscribe(
        seriesDocumentary => {
        obs.next(seriesDocumentary);
      },
      err => {
        obs.error(err);
      });
    });
  }

  /**
   * Consutar todas las subseries
   *
   * @returns {Observable<SubSeriePredeterminada[]>}
   * @memberof DocumentsDataService
   */
  getSubseriesDocumentary(): Observable<SubSeriePredeterminada[]> {
    return new Observable(obs => {
      this.http.get<SubSeriePredeterminada[]>(this.api.get('adminSubSerie')).subscribe(
        subSeriesDocumentary => {
          obs.next(subSeriesDocumentary);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consultar todos los tipos documentales
   *
   * @returns {Observable<TipoDocumentalPredeterminado[]>}
   * @memberof DocumentsDataService
   */
  getTypeDocumentary(): Observable<TipoDocumentalPredeterminado[]> {
    return new Observable(obs => {
      this.http.get<TipoDocumentalPredeterminado[]>(this.api.get('adminTypeDocument')).subscribe(
        typeDocumentary => {
          const typeDocumentaryAux: TipoDocumentalPredeterminado[] = [];
          if (typeDocumentary.length) {
            typeDocumentary.forEach(type => {
              typeDocumentaryAux.push({
                id: type.id,
                nombre: type.nombre,
                codigo: type.codigo,
                rutas: type.rutas,
                ruta_generacion: type.rutas ?
                type.rutas.length ?
                type.rutas[0].ruta_generacion ?
                                      true
                                    : false
                                  : false
                                 : false,
                subserie: type.subserie,
                expediente:  type ? type.expediente : false
              });
            }
            );
          }
        obs.next(typeDocumentaryAux);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consultar clasificaciones
   *
   * @returns {Observable<ClasificacionPredeterminada[]>}
   * @memberof DocumentsDataService
   */
  getDocumentClassification(): Observable<ClasificacionPredeterminada[]> {
    return new Observable(obs => {
      this.http.get<ClasificacionPredeterminadaAPI[]>(this.api.get('adminDocument')).subscribe(
        documentClassificationApi => {
          const documentClassification: ClasificacionPredeterminada[] = [];
          if (documentClassificationApi.length) {
            documentClassificationApi.forEach(document => {
              documentClassification.push({
                id: document.id,
                nombre: document.nombre,
                tipo_documental: document.tipo_documental,
                rutas: document.rutas,
                ruta_vista_previa: document.rutas ?
                                    document.rutas.length ?
                                      document.rutas[0].ruta_vista_previa ?
                                        true
                                      : false
                                    : false
                                   : false,
                ruta_generacion: document.rutas ?
                                  document.rutas.length ?
                                    document.rutas[0].ruta_generacion ?
                                      true
                                    : false
                                  : false
                                 : false,
                solicitud: document ? document.solicitud : false
              });
            });
          }
          obs.next(documentClassification);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/shared/documents.data.service.ts